import Image from "next/image";
import styles from "./AnalyzeCustomer.module.scss";
function AnalyzeCustomer(props: any) {
  return (
    <div className={styles["analyze-customer-wrapper"]}>
      <div className={styles["analyze-customer-content"]}>
        <h2>{props.title}</h2>
      </div>
      <div className={styles["analyze-customer-image"]}>
        <Image
          src={props.image}
          alt=""
          width={400}
          height={300}
          className={styles["analyze-image"]}
        ></Image>
      </div>
    </div>
  );
}

export default AnalyzeCustomer;
